import { Link, useLocation } from 'react-router-dom';
import { Columns3, List } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

type Props = {
  isKanban: boolean;
  listSearch: string;
  boardSearch: string;
};

export default function WorkLayoutSwitch({ isKanban, listSearch, boardSearch }: Props) {
  const location = useLocation();

  return (
    <div className="inline-flex items-center gap-0.5" role="group" aria-label="Layout">
      <Button
        asChild
        variant="ghost"
        size="sm"
        className={cn(
          'h-8 gap-1.5 px-2.5 font-medium',
          !isKanban ? 'bg-muted text-foreground' : 'text-muted-foreground',
        )}
      >
        <Link
          to={{ pathname: location.pathname, search: listSearch }}
          replace
          aria-current={!isKanban ? 'page' : undefined}
        >
          <List className="h-4 w-4" aria-hidden />
          List
        </Link>
      </Button>
      <Button
        asChild
        variant="ghost"
        size="sm"
        className={cn(
          'h-8 gap-1.5 px-2.5 font-medium',
          isKanban ? 'bg-muted text-foreground' : 'text-muted-foreground',
        )}
      >
        <Link
          to={{ pathname: location.pathname, search: boardSearch }}
          replace
          aria-current={isKanban ? 'page' : undefined}
        >
          <Columns3 className="h-4 w-4" aria-hidden />
          Board
        </Link>
      </Button>
    </div>
  );
}
